/**
 * Admin Reference Data Page
 * Manages reference data entities behind tabbed navigation.
 * Tabs: User Categories, Instrument List (search with broker mappings).
 */

import { useState } from 'react';
import {
    Box,
    Tabs,
    Tab,
} from '@mui/material';
import { AuthenticatedLayout } from '../../components/layout/AuthenticatedLayout';
import { UserCategoriesTab } from './tabs/UserCategoriesTab';
import { InstrumentListTab } from './tabs/InstrumentListTab';
import { BrokersTab } from './tabs/BrokersTab';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel({ children, value, index }: TabPanelProps) {
    return (
        <Box role="tabpanel" hidden={value !== index} sx={{ pt: 3 }}>
            {value === index && children}
        </Box>
    );
}

export function AdminReferenceDataPage() {
    const [tab, setTab] = useState(0);

    return (
        <AuthenticatedLayout>
            <Box>


                {/* Tabs */}
                <Box
                    sx={{
                        borderBottom: '1px solid rgba(4, 55, 123, 0.2)',
                        background: '#fff',
                        borderRadius: '8px 8px 0 0',
                        border: '1px solid rgba(4, 55, 123, 0.2)',
                        px: 2,
                    }}
                >
                    <Tabs
                        value={tab}
                        onChange={(_, v) => setTab(v)}
                        sx={{
                            '& .MuiTab-root': {
                                textTransform: 'none',
                                color: '#04377b',
                                fontWeight: 500,
                                fontSize: '0.875rem',
                                '&.Mui-selected': { fontWeight: 600 },
                            },
                            '& .MuiTabs-indicator': { backgroundColor: '#04377b' },
                        }}
                    >
                        <Tab label="User Categories" />
                        <Tab label="Instruments" />
                        <Tab label="Brokers" />
                    </Tabs>
                </Box>

                <TabPanel value={tab} index={0}>
                    <UserCategoriesTab />
                </TabPanel>
                <TabPanel value={tab} index={1}>
                    <InstrumentListTab />
                </TabPanel>
                <TabPanel value={tab} index={2}>
                    <BrokersTab />
                </TabPanel>
            </Box>
        </AuthenticatedLayout>
    );
}
